import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, MotionConfig } from 'framer-motion';
import Login from './pages/Login';
import CensusChoice from './pages/CensusChoice';
import PersonalDataForm from './pages/PersonalDataForm';
import AddressForm from './pages/AddressForm';
import DependentsForm from './pages/DependentsForm';
import DeclarantForm from './pages/DeclarantForm';
import DocumentsForm from './pages/DocumentsForm';
import ProtocolsForm from './pages/ProtocolsForm';
import DetectionFace from './pages/DetectionFace';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminRegister from './pages/AdminRegister';
import { AuthProvider } from './context/AuthContext';
import { AdminAuthProvider } from './context/AdminAuthContext';
import RequireAdminAuth from './components/RequireAdminAuth';
import CensoPresencial from './pages/CensoPresencial';
import PoloSelection from './pages/PoloSelection';
import PageCenso from './pages/pageCenso';
import PagePolo from './pages/PagePolo';

const AnimatedRoutes: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // o próprio <body> rola o conteúdo nesta app (ver index.css), então
    // window.scrollTo sozinho não reseta a posição ao trocar de etapa
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [location.pathname]);

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/rj" element={<Login />} />
            <Route path="/rj/census-choice" element={<CensusChoice />} />
            <Route path="/rj/polo-selection" element={<PoloSelection />} />
            <Route path="/rj/personal-data" element={<PersonalDataForm />} />
            <Route path="/rj/address" element={<AddressForm />} />
            <Route path="/rj/declarant" element={<DeclarantForm />} />
            <Route path="/rj/dependents" element={<DependentsForm />} />
            <Route path="/rj/documents" element={<DocumentsForm />} />
            <Route path="/rj/protocols" element={<ProtocolsForm />} />
            <Route path="/rj/detection-face" element={<DetectionFace />} />
            <Route path="/rj/admin-login" element={<AdminLogin />} />
            <Route
              path="/rj/admin/dashboard"
              element={
                <RequireAdminAuth>
                  <AdminDashboard />
                </RequireAdminAuth>
              }
            />
            <Route
              path="/rj/censo-presencial"
              element={
                <RequireAdminAuth>
                  <CensoPresencial />
                </RequireAdminAuth>
              }
            />
            <Route
              path="/rj/admin/censo"
              element={
                <RequireAdminAuth>
                  <PageCenso />
                </RequireAdminAuth>
              }
            />
            <Route
              path="/rj/admin/polos"
              element={
                <RequireAdminAuth>
                  <PagePolo />
                </RequireAdminAuth>
              }
            />
            <Route
              path="/rj/admin/register"
              element={
                <RequireAdminAuth>
                  <AdminRegister />
                </RequireAdminAuth>
              }
            />
      </Routes>
    </AnimatePresence>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <AdminAuthProvider>
        <Router>
          <MotionConfig reducedMotion="user">
            <AnimatedRoutes />
          </MotionConfig>
        </Router>
      </AdminAuthProvider>
    </AuthProvider>
  );
};

export default App;